import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import DashboardSidebar from './DashboardSidebar';
import DashboardHeader from './DashboardHeader';

const pageTitles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/dashboard/counselors': 'Counselors',
  '/dashboard/team': 'Team & Access',
  '/dashboard/hr': 'Staff HR & Attendance',
  '/dashboard/students': 'Students',
  '/dashboard/institutions': 'Universities & Courses',
  '/dashboard/applications': 'Application Management',
  '/dashboard/visa': 'Visa & Pre-Departure',
  '/dashboard/documents': 'Document Management',
  '/dashboard/finance': 'Finance',
  '/dashboard/leads': 'Leads',
  '/dashboard/appointments': 'Appointments',
  '/dashboard/tasks': 'Tasks & Communications',
  '/dashboard/activity': 'Activity Logs',
  '/dashboard/reports': 'Reports',
  '/dashboard/subscription': 'Subscription',
  '/dashboard/settings': 'Settings',
};

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const title = location.pathname.startsWith('/dashboard/students/') ? 'Student Profile' : pageTitles[location.pathname] || 'Dashboard';

  return (
    <div className="min-h-screen bg-[#F8F9FB]">
      <DashboardSidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <DashboardHeader title={title} collapsed={collapsed} />
      <main
        className={`transition-all duration-300 pt-16 min-h-screen ${
          collapsed ? 'ml-16' : 'ml-60'
        }`}
      >
        <div className="p-4 md:p-6">{children}</div>
      </main>
    </div>
  );
}
